import { Types } from '@grandvisionhq/graphql';
import { enumValueToString } from '@grandvisionhq/utils';

const fromStoreQueryToStore = (storeQueryData)=>{
    if (!storeQueryData) {
        return null;
    }
    try {
        const { code , name: name1 , shortName , email , streetName , streetNumber , additionalStreetInfo , postalCode , town , province , country , lat , lon , phone , slug , appointmentTypes ,  } = storeQueryData;
        var _amount, _unit;
        return {
            code,
            name: name1,
            shortName,
            streetName,
            town,
            country,
            phone,
            slug: slug !== null && slug !== void 0 ? slug : undefined,
            streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
            additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : undefined,
            postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : undefined,
            province: province !== null && province !== void 0 ? province : undefined,
            lat: lat !== null && lat !== void 0 ? lat : undefined,
            lon: lon !== null && lon !== void 0 ? lon : undefined,
            emailAddress: email !== null && email !== void 0 ? email : undefined,
            appointmentTypes: appointmentTypes.filter(({ isAvailableInStore  })=>isAvailableInStore
            ).map(({ id , name , description , duration , price , ageGroup  })=>({
                    id,
                    name,
                    description: description !== null && description !== void 0 ? description : '',
                    duration: {
                        amount: (_amount = duration.amount) !== null && _amount !== void 0 ? _amount : 0,
                        unit: (_unit = duration.unit) !== null && _unit !== void 0 ? _unit : 'MINUTES'
                    },
                    price: price !== null && price !== void 0 ? price : undefined,
                    ageGroup: enumValueToString(Types.AppointmentTypeAgeGroup, ageGroup)
                })
            )
        };
    } catch (e) {
        console.error('Store query data adapter failed to parse input data correctly.', e, storeQueryData);
        return null;
    }
};

export { fromStoreQueryToStore };
//# sourceMappingURL=from-store-query-to-store.js.map
